/* 🤖 this file was generated by svg-to-ts */
export const matIconDifference: {
  name: 'difference';
  data: string;
} = {
  name: 'difference',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M18 23H4c-1.1 0-2-.9-2-2V7h2v14h14v2zM14.5 7V5h-2v2h-2v2h2v2h2V9h2V7h-2zm2 6h-6v2h6v-2zM15 1H8c-1.1 0-1.99.9-1.99 2L6 17c0 1.1.89 2 1.99 2H19c1.1 0 2-.9 2-2V7l-6-6zm4 16H8V3h6.17L19 7.83V17z"/></svg>`
};
